import { sumBy } from 'lodash';
import { FundAllocation } from '../index';

/**
 * Calculates the total value for a specific field across all fund allocations
 * @param formFundAllocations - Array of fund allocations from the form
 * @param watchedValues - Current form values being watched
 * @param fieldName - The field name to sum (e.g., 'finalShareholding', 'adjustedNetInvestmentExFee')
 * @returns The total sum of the specified field across all fund allocations
 */
const getTotalValuesForField = (
  formFundAllocations: Array<FundAllocation>,
  watchedValues: { fundAllocations?: Array<any> },
  fieldName: string,
): number => {
  return sumBy(
    formFundAllocations.map((_fund, fundIndex) => ({
      [fieldName]: sumBy(
        watchedValues.fundAllocations?.[fundIndex]?.investments ?? [],
        fieldName,
      ),
    })),
    fieldName,
  );
};

export default getTotalValuesForField;
